enum InputState {
  IDLE,
  PENDING,
  LOCKED
};

export default InputState;
